import React from 'react';
import { Icon } from './Icon';
import { useTheme } from '@/hooks/useTheme';

interface EmptyStateProps {
  icon?: string;
  title: string;
  subtitle?: string;
}

export function EmptyState({ icon = 'search', title, subtitle }: EmptyStateProps) {
  const colors = useTheme();

  return (
    <div style={styles.container}>
      <div style={{ opacity: 0.5, marginBottom: 12 }}>
        <Icon name={icon} size={48} color={colors.textSecondary} />
      </div>
      <div style={{ ...styles.title, color: colors.textSecondary }}>{title}</div>
      {subtitle && <div style={{ ...styles.subtitle, color: colors.textSecondary }}>{subtitle}</div>}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 48,
    paddingBottom: 48,
    paddingLeft: 24,
    paddingRight: 24,
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 14,
    textAlign: 'center',
    marginTop: 4,
  },
};
